///<reference path="../../employee/sections/employee.deduction.section.ts"/>
module Meevo.Plugins.EmployeeTemplates {
  "use strict";

  /**
  * Deduction Section of Employee 
  */
  export class DeductionSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeTemplateDeduction> {
      // Feature 140532: same show/hide rule as the Employee Deductions tab (hidden only in After Commission mode)
      isZeroDollarDeductionVisible(): boolean {
          return Meevo.Plugins.Employee.DeductionSection.isZeroDollarDeductionVisible(this.model);
      }

  }
}